<template>
  <v-select
    dense
    :id="field.id"
    :name="field.name"
    :items="field.choices"
    :label="field.label"
    :required="field.required"
    :rules="field.required && [rules.required] || []"
    :value="field.value"
    v-on:change="changeProcess"
  >
  </v-select>

</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import QUnit from '@/api/QUnit'

export default {
  name: 'ProcessSelectComponent',
  props: {
    field: Object
  },
  data() {
    return {      
      rules: {
          required: v => !!v || 'Field is mandatory'
        }
    }
  },
  methods: {
    changeProcess(p){
      console.log(p)
      this.SET_FORM_PROCESS(p)
    },
    ...mapMutations([
      'SET_FORM_PROCESS',
    ]),    
  },
  
}
</script>
